<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Evolución</span>
</mat-toolbar>

<div class="group-bar">
  <div class="group-bar-scroll">
    <button
      type="button"
      class="group-chip"
      [class.active]="groupSelected === 'general'"
      (click)="selectGroup('general')"
    >
      🌍 General
    </button>
    @for (group of groups; track group) {
      <button
        type="button"
        class="group-chip"
        [class.active]="groupSelected === group._id"
        (click)="selectGroup(group._id)"
      >
        {{ group.name }}
      </button>
    }
  </div>
</div>

<div class="stats-evolution-page">
  <div class="stats-evolution-grid">
    <app-standings-evolution-chart
      [title]="'Evolución de posiciones'"
      [subtitle]="'Top del grupo y tu seguimiento por jornada'"
      [labels]="positionEvolutionLabels"
      [series]="positionEvolutionSeries"
      [yAxisMode]="'position'"
    ></app-standings-evolution-chart>

    <app-standings-evolution-chart
      [title]="'Evolución de puntos'"
      [subtitle]="'Puntos acumulados de los líderes y tu usuario'"
      [labels]="pointsEvolutionLabels"
      [series]="pointsEvolutionSeries"
      [yAxisMode]="'points'"
    ></app-standings-evolution-chart>
  </div>
</div>
